import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import {withBranchProps} from '../../../../../../../hooks/routes'
import type {State} from '../../../../../../../reducers/types'
import {getStatus} from '../../../../../../../selectors'
import {getStatusRequest} from '../../../../../../../types'

import BuildTypeStatus from './BuildTypeStatus'
import type {OwnProps, StateProps} from './BuildTypeStatus.types'

const mapStateToProps = (state: State, {buildTypeId, branch}: OwnProps): StateProps => {
  const status = getStatus(state, getStatusRequest('bt', buildTypeId, branch))
  return {
    queued: status?.queued ?? 0,
    loading: status == null,
  }
}

export default compose(withBranchProps, connect(mapStateToProps, {}))(BuildTypeStatus)
